import React, { Component } from "react";
import { Icon, Card, Select } from "antd";
import { Translate } from "react-translated";
import StatBox from "../../../../components/stat-box";

const Option = Select.Option;

class TotalOpportunitiesUncovered extends Component {
  state = {
    filter_lsp: this.props.filter_lsp,
    expandStats: false,
    period: this.props.period,
    start_date: this.props.start_date,
    end_date: this.props.end_date,
    vo_totals: {
      count: 0,
    },
  };

  filterLSP = (val) => {
    this.setState({
      filter_lsp: val,
    });
    this.props.setInternalFilterChange(true);
  };

  componentDidUpdate() {
    const {
      period,
      start_date,
      end_date,
      filter_lsp,
      internalFilterChange,
    } = this.props;

    if (
      (period !== this.state.period ||
        start_date !== this.state.start_date ||
        end_date !== this.state.end_date ||
        filter_lsp !== this.state.filter_lsp) &&
      !internalFilterChange
    ) {
      this.setState({
        period,
        start_date,
        end_date,
        filter_lsp,
      });
    }
  }

  render() {
    const {
      dashboard,
      user,
      loading,
      period,
      start_date,
      end_date,
    } = this.props;

    let { associations } = this.props;

    associations = associations.filter((item) => item.id !== user.id);

    // F.log("Props =>", this.props);
    const { filter_lsp } = this.state;

    let need_attention = 0,
      sent_to_vonboarder = 0,
      life_opportunities = 0,
      saved_for_later = 0;

    if (filter_lsp !== "") {
      for (let i = 0, len = dashboard.lsp.length; i < len; i++) {
        if (dashboard.lsp[i].user.email === filter_lsp) {
          const user_stats = dashboard.lsp[i].stats;
          need_attention = user_stats.user_need_attention;
          sent_to_vonboarder = user_stats.user_sent_to_vonboarder;
          life_opportunities = user_stats.user_life_opportunities;
          saved_for_later = user_stats.user_saved_for_later;
          break;
        }
      }
    } else {
      need_attention = dashboard.agency_stats.need_attention;
      sent_to_vonboarder = dashboard.agency_stats.sent_to_vonboarder;
      life_opportunities = dashboard.agency_stats.life_opportunities;
      saved_for_later = dashboard.agency_stats.saved_for_later;
    }

    let date_url = "";
    // if (period === "from_to") {
    //   date_url =
    //     "/all/" +
    //     encodeURIComponent(moment(start_date).format("MM/DD/YYYY")) +
    //     "/" +
    //     encodeURIComponent(moment(end_date).format("MM/DD/YYYY"));
    // }
    if (period === "all_bfiles") {
      date_url = "?all_bfiles";
    }

    return (
      <div style={{ marginBottom: 20 }}>
        <Card
          title={
            <div>
              <Icon
                type="appstore"
                style={{ marginRight: 10, color: "#1890ff" }}
              />
              <Translate text={`B File Status`} />
            </div>
          }
          bordered={false}
          className="statsDetails have_extra"
          extra={
            user.user_type !== "AGENCY_MANAGER" && (
              <Select
                value={filter_lsp}
                style={{ width: 200 }}
                onChange={this.filterLSP}
              >
                <Option value="">
                  <Translate text={`Select Agent`} />
                  ...
                </Option>
                <Option value={user.email}>
                  <Translate text={`Me`} />
                </Option>

                {associations
                  .map((asso, i) => {
                    if (asso.user_type === "LSP" || asso.user_type === "EA") {
                      return (
                        <Option value={asso.email} key={i}>
                          {asso.first_name + " " + asso.last_name}
                        </Option>
                      );
                    } else {
                      return null;
                    }
                  })
                  .filter(Boolean)}
              </Select>
            )
          }
        >
          <div className="statsGrid">
            <Card bordered={false} loading={loading}>
              <StatBox
                title="Total B Files Created"
                val={life_opportunities}
                color={"blue2"}
                link={"/bfiles/life-opportunities" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              <StatBox
                title="Sent for Internal Follow Up"
                val={need_attention}
                color={"blue1"}
                link={"/bfiles/cross-sell-policies-uncovered" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              <StatBox
                title="Sent for Follow-Up Specialist"
                val={sent_to_vonboarder}
                color={"purple"}
                link={"/bfiles/sent-to-vonboarder" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
              {/* <StatBox
                  title="No Follow Up Requested"
                  val={sent_follow_up ? sent_follow_up : 0}
                  color={"blue4"}
                  link={"/bfiles/sent-for-follow-up" + date_url}
                /> */}
              <StatBox
                title="Saved for Later"
                val={saved_for_later}
                color={"blue4"}
                link={"/bfiles/saved_for_later" + date_url}
                user_type={user.user_type}
                history={this.props.history}
                filter_lsp={filter_lsp}
                period={period}
                start_date={start_date}
                end_date={end_date}
                gridStyleWidth="25%"
              />
            </Card>
          </div>
        </Card>
      </div>
    );
  }
}

export default TotalOpportunitiesUncovered;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/parts/lsp/bfile-status.js